import React from 'react'
import Routes from '../../../startup/routes'
import { IconGlyph } from '../../../icons/IconGlyph'

// TODO: add types
type Props = { closeModal; ctaLink }

const PlaceSignUpUpsell: React.FC<Props> = ({ closeModal, ctaLink }) => (
  <div className="upsellModal">
    <IconGlyph name="cancel-circle" className="ReactModal-modal-closeIcon" onClick={closeModal} />
    <h2 className="upsellModal-title">Feature your business or place of interest.</h2>
    <div className="upsellModal-subtitle">Create a free CivicLift account to make a submission.</div>
    <a target="_blank" rel="noopener noreferrer" href={ctaLink} className="btn upsellModal-cta">
      Create <span className="show-for-medium">Your Free</span> Account
    </a>
    <p className="upsellModal-haveAccount prompt-sign-in">
      Already have an account?{' '}
      <a target="_blank" rel="noopener noreferrer" href={Routes.signIn()}>
        Sign in
      </a>
      .
    </p>
    <ul className="upsellModal-upsellPoints">
      <li>Submit, manage, and promote your listing</li>
      <li>Subscribe to all of the communities you care about</li>
      <li>
        Discover things to do and places to go - based on <em>your</em> interests
      </li>
    </ul>
    <div className="upsellModal-footer">
      <img src="/img/logo_slogan.svg" />
    </div>
  </div>
)

export default PlaceSignUpUpsell
